import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { womenDoctors, WomenCareBestPackage, womenCareCategory } from './womencareData';
import { Grid } from '@mui/material';
import './womencare.css';
const WomanCare = () => {
    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 1,
            slidesToSlide: 1
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };
    const categoryCaresolResponsive={
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 1200 },
            items: 5,
            slidesToSlide: 5
        },
        desktop: {
            breakpoint: { max: 1200, min: 1000 },
            items: 4,
            slidesToSlide: 4
        },
        smallSesktop: {
            breakpoint: { max: 1000, min: 800 },
            items: 3,
            slidesToSlide: 3
        },
        tablet: {
            breakpoint: { max: 800, min: 450 },
            items: 2,
            slidesToSlide: 2
        },
        mobile: {
            breakpoint: { max: 450, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    }
    return (
        <>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={false}
                className=""
                containerClass="container-with-dots"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                <div >
                    <img style={{ height: '350px', width: '100%' }} alt="" src="https://medibiotest-gallery.s3.ap-south-1.amazonaws.com/banner1.png" />
                </div>
                <div >
                    <img style={{ height: '350px', width: '100%' }} alt="" src="https://medibiotest-gallery.s3.ap-south-1.amazonaws.com/banner2.png" />
                </div>
            </Carousel>
            <Grid container spacing={3} marginTop={5} justifyContent="center">
                {
                    womenDoctors && womenDoctors.map((data) => {
                        return (
                            <>
                                <Grid item alignItems="center" container xs={10} margin={2} padding={3} sm={5} md={3} lg={3} className='women-care-border-radius women-care-details'>
                                    <Grid item xs={10} sm={12} md={12} lg={5}>
                                        <div className='women-care-image'>
                                            <img src={data.img} />
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={12} lg={6}>
                                        <div className='women-care-doctor-name'>{data.doctorName}</div>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    })
                }
            </Grid>
            <Grid container spacing={3} marginTop={5} justifyContent="center">
                <Grid item xs={10} sm={10} md={6} lg={6}>
                    <div className='women-care-health-doctor-name'>About Women's Health</div>
                    <div className='women-care-health-detail'>
                        <div>
                            Women, being the backbone for any family, caring about them is very important and hence we provide solutions. Women's care provides medical services and support to women to help them maintain good health throughout their lives. These include preventive care, diagnostic services and treatment for various conditions that can affect women's health.
                        </div>
                        <br />
                        <div>
                            Common areas of assistance that we provide include period tracker, reproductive health, breast health, menopause and hormonal health, mental health and general health.
                        </div>
                        <div>
                            <br />
                            The period tracker can help in handling painful menstrual cramps, avoid heavy bleedings and handle mood swings, digestive issues, fatigue and weakness.
                        </div>
                        <div>
                            <br />
                            Other services include contraception, fertility treatments, prenatal care, gynaecological exams, breast cancer screenings, mammograms and breast health education.
                        </div>
                        <div>
                            <br />
                            Also we help in treatments and management of symptoms associated with menopause and other hormonal imbalances, support for mental health concerns such as anxiety, depression and postpartum depression.
                        </div>
                    </div>
                </Grid>
                <Grid item xs={10} sm={10} md={4} lg={4}>
                    <div className='women-care-health-image'>
                        <img src="data:image/jpeg;base64,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" />
                    </div>
                </Grid>
            </Grid>
            <Grid container justifyContent="center" paddingTop={5}>
                <Grid item padding={3.3} xs={10} sm={10} md={10} lg={10} className='women-care-health-message'>
                    Women require regular check-ups and preventive care for conditions such as heart disease, diabetes and cancer, which can affect women differently than men. It is important for women to seek out regular care and support to maintain good health and prevent serious health problems.
                </Grid>
            </Grid>
            <Grid container spacing={3} marginTop={5} justifyContent="center">
                <Grid item xs={11} sm={11} md={10} lg={10} className='women-care-package'>
                    Women Care Best Packages
                </Grid>
                {
                    WomenCareBestPackage && WomenCareBestPackage.map((data) => {
                        return (
                            <>
                                <Grid item alignItems="center" container margin={2} padding={3} xs={10} sm={5} md={2.2} lg={2.2} className='women-care-border-radius'>
                                    <div>
                                        <div className='women-care-package-image'>
                                            <img src={data.img} />
                                        </div>
                                        <div className='women-care-package-name'>{data.packageName}</div>
                                        <div className=''>{data.packageDetails}</div>
                                        <div className='women-care-package-view-button'>
                                            <button>View More</button>
                                        </div>
                                    </div>
                                </Grid>
                            </>
                        )
                    })
                }
            </Grid>
            <div className="category-container">
                <Grid container justifyContent="center" paddingTop={3}>
                    <Grid item paddingLeft={2} xs={11.5} sm={11.9} md={10} lg={10}>
                        <div className="category-says">
                            <div >
                                CATEGORIES
                            </div>
                            <div>
                            <b>Women Care</b>
                            </div>
                        </div>
                    </Grid>
                </Grid>
                <Grid container justifyContent="center" paddingTop={3}>
                    <Grid item xs={12} sm={12} md={10} lg={10}>
                        <Carousel
                            additionalTransfrom={0}
                            arrows
                            autoPlaySpeed={3000}
                            centerMode={false}
                            className=""
                            containerClass="container-with-dots"
                            dotListClass=""
                            draggable
                            focusOnSelect={false}
                            infinite
                            itemClass=""
                            keyBoardControl
                            minimumTouchDrag={80}
                            pauseOnHover
                            renderArrowsWhenDisabled={false}
                            renderButtonGroupOutside={false}
                            renderDotsOutside={false}
                            responsive={categoryCaresolResponsive}
                            rewind={false}
                            rewindWithAnimation={false}
                            rtl={false}
                            shouldResetAutoplay
                            showDots={false}
                            sliderClass=""
                            slidesToSlide={1}
                            swipeable
                        >
                            {
                                womenCareCategory && womenCareCategory.map((data)=>
                                     <>
                                    <div className='women-care-package-details'>
                                    <div className='women-care-package-image'>
                                            <img src={data.img} />
                                        </div>
                                        <div className='women-care-package-category'>{data.categoryName}</div>
                                    </div>
                                     </>
                                )
                            }
                            
                        </Carousel>
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
export default WomanCare;